import { EntityBinding } from "./BaseEntityRecordBinding";

export const MetadataRegistry = new Map<string, EntityBinding<any>>();
export function MetaBinding(): ClassDecorator {
    return (target) => {
        const binding = target as any as { metadata: () => EntityBinding<any> };
        if (binding && typeof binding.metadata == "function") {
            const metadata = binding.metadata();
            MetadataRegistry.set(metadata.entityName, metadata);
        }
    };
}
